import chatttSDK from 'services/chattt';

const isInClient = chatttSDK !== undefined;

export default {
  storage: isInClient ? sessionStorage : localStorage,
  cacheKey: `@${process.env.REACT_APP_NAME}-token`,
};
